import { Manrope } from 'next/font/google';

// NOTE: This is intentionally module-scoped (not inside an arrow function/component).
// Next.js `next/font` loaders must be called and assigned to a const at module scope.
const themePrimaryFont = Manrope({
  subsets: ['latin'],
  variable: '--font-manrope',
  display: 'swap',
  // Keep 500 and 800: existing CSS uses those weights (headings, mixins). Dropping them
  // would synthesize/fallback and change this app’s type. Gueysos PageSpeed trim is 400/600/700
  // only when those extra weights are unused in the consumer.
  weight: ['400', '500', '600', '700', '800'],
});

/**
 * Primary UI font registration. Swap `Manrope` or options on `themePrimaryFont` above — root layout should only read `ThemeFonts.variable`.
 */
export const ThemeFonts = {
  variable: themePrimaryFont.variable,
} as const;
